export default __webpack_public_path__ + "static/media/Login.6bc3665d.png";